import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import GPWebSignin from "../../../components/gp-web-login/gp-web-signin";
import "./gp-web-signin-page.css";
import backArrow from '../../../../media/back-arrow.svg'
import constants from "../../../constants";
import { SEND_POST_MESSAGE, LOGIN_FAIL } from "../../../actions";

export class GPWebSigninPage extends Component {
  constructor(props) {
    super(props);
  }

  onClickBack = (e) => {
    e.preventDefault();

    this.props.router.goBack();
  }

  componentDidUpdate(prevProps) {
    if (this.props.authData && prevProps && (this.props.authData !== prevProps.authData)) {
      this.props.handleAction(SEND_POST_MESSAGE, this.props.authData);

      if (this.props.authData.hasAdFreeSubscription) {
        this.props.router.push(`/gp-web/plans-thank-you/${this.props.authData.email}/2/${constants.CURRENCY_SYMBOL}`)
      } else {
        this.props.handleAction(LOGIN_FAIL, {data: {error_description: this.props.t('GP_THANK_YOU_LOGIN_FAIL_MESSAGE')}})
        // this.props.router.push(`/gp-web/plans-checkout`)
      }
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div className="page">
        {document.referrer &&
          <a href={document.referrer} className="back" onClick={this.onClickBack}>
            <img alt={t('BACK')} src={backArrow} />
            
            {t('BACK')}
          </a>
        }
        
        <GPWebSignin {...this.props} />
      </div>
    );
  }
}

GPWebSigninPage.propTypes = {
  t: PropTypes.func.isRequired,
};

GPWebSigninPage.defaultProps = {};

const mapStateToProps = (state) => ({
  ...state.app,
  ...state.auth,
  signInError: state.session.signInError,
  missingFields: state.session.missingFields,
  clientId: state.session.client_id,
  provider: state.session.provider,
  providerSecret: state.session.providerSecret,
  providerToken: state.session.providerToken,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(GPWebSigninPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/gp-web-login-page/gp-web-signin-page.js